module.exports = __webpack_public_path__ + "media/img/pages/companies/vermo_gens_zentrum-2a44d5ced95fed2b171d5abf1fb35eff.png";